import React from 'react';
import { Table } from 'antd';
import { Button } from 'react-bootstrap';
import { Edit } from 'react-feather';
import LoadingSpinner from '../../InitialPage/Sidebar/LoadingSpinner';
import { getAsnSourceFileName, isAsnOriginShipment } from './mappings-asn';

const MappingsTable = ({ shipments = [], loading = false, onViewShipment }) => {
  const handleViewClick = record => {
    if (onViewShipment) onViewShipment(record);
  };

  const columns = [
    {
      title: 'Shipment Number',
      dataIndex: 'shipmentNumber',
      sorter: (a, b) => a.shipmentNumber?.localeCompare(b.shipmentNumber) || 0,
    },
    {
      title: 'Date',
      dataIndex: 'shipmentDate',
      sorter: (a, b) => a.shipmentDate?.localeCompare(b.shipmentDate) || 0,
    },
    {
      title: 'Appointment',
      dataIndex: 'appointmentDateTime',
      render: text => text || 'N/A',
      sorter: (a, b) =>
        (a.appointmentDateTime || '').localeCompare(b.appointmentDateTime || ''),
    },
    {
      title: 'Supplier',
      dataIndex: 'supplierName',
      render: text => text || '',
      sorter: (a, b) => (a.supplierName || '').localeCompare(b.supplierName || ''),
    },
    {
      title: 'Status',
      dataIndex: 'status',
      render: (text, record) => (
        <span>
          <span
            style={{
              backgroundColor: record.backgroundColor || '#e0e0e0',
              color: record.textColor || '#000000',
              padding: '4px 8px',
              borderRadius: '4px',
            }}
          >
            {text || 'N/A'}
          </span>
          {isAsnOriginShipment(record) ? (
            <span
              className="badge ms-1"
              style={{ backgroundColor: '#02a8b5', color: '#fff' }}
              title={getAsnSourceFileName(record)}
            >
              ASN
            </span>
          ) : null}
        </span>
      ),
      sorter: (a, b) => (a.status || '').localeCompare(b.status || ''),
    },
    {
      title: 'Actions',
      dataIndex: 'receivingShipmentID',
      key: 'actions',
      render: (text, record) => (
        <div className="action-table-data">
          <div className="edit-delete-action">
            <Button variant="light" size="sm" onClick={() => handleViewClick(record)}>
              <Edit size={16} />
            </Button>
          </div>
        </div>
      ),
    },
  ];

  return (
    <div className="table-responsive product-list">
      {loading && <LoadingSpinner />}
      <Table columns={columns} dataSource={shipments} rowKey="receivingShipmentID" />
    </div>
  );
};

export default MappingsTable;
